import React, { useRef, useEffect } from "react";
import enFlag from "../../assets/langFlags/en.svg";
import frFlag from "../../assets/langFlags/fr.svg";
import deFlag from "../../assets/langFlags/de.svg";
import esFlag from "../../assets/langFlags/es.svg";

const LanguageModal = ({
  currentLanguage,
  toggleLanguageModal,
  handleLanguageChange,
  triggerRef,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideModal =
        modalRef.current && !modalRef.current.contains(event.target);
      const clickedTrigger =
        triggerRef.current && triggerRef.current.contains(event.target);

      if (clickedOutsideModal && !clickedTrigger) {
        toggleLanguageModal();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [toggleLanguageModal, triggerRef]);

  const languageOptions = [
    { code: "en", label: "English", flag: enFlag },
    { code: "fr", label: "Français", flag: frFlag },
    { code: "es", label: "Español", flag: esFlag },
    { code: "de", label: "Deutsch", flag: deFlag },
  ];

  const handleClick = (code) => {
    if (code === currentLanguage) return;

    handleLanguageChange(code);
    toggleLanguageModal();
  };


  return (
    <div ref={modalRef} className="language-dropdown">
      {languageOptions.map(({ code, label, flag }) => (
        <button
          key={code}
          className={`language-button ${
            currentLanguage === code ? "active-dropdown-item" : ""
          }`}
          onClick={() => handleClick(code)} 
          disabled={currentLanguage === code}
        >
          <img src={flag} alt={`${label} flag`} />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageModal;